/*
defines functionality for controlling the menu and its associated functions
*/
import apis from 'utilities/api';
import {randomizeSources} from 'utilities/utilities';
import GraphState from './state';

/**
 * represents a controller for menu buttons
 */
export default class MenuController {
    /**
     * makes a new menu controller given a graph controller, model, and view
     * @param {GraphController} graphController the graph controller to use
     * @param {Graph} model the graph model instance to use
     * @param {GraphView} view the graph view to use
     */
    constructor(graphController, model, view) {
        this.graphController = graphController;
        this.model = model;
        this.view = view;
        this.state = new GraphState(this);
        this.apisOff = new Set([]);
    }

    /**
     *
     */
    initHandlers() {
        this.initLightboxHandler();
        this.initFunctionButtonHandlers();
        this.initLightboxHandler();
        this.initAddNodeHandler();
        this.initFiltersHandler();
        this.initCastHandler();
        //this.showQrCode();
    }


    /**
     * binds the handlers for the function buttons
     * some functions are commented out
     */
    initFunctionButtonHandlers() {
        // this.view.physicsButton.on('click.physics', () => this.onTogglePhysics());
        // this.view.reorganizeButton.on('click.reorganize', () => this.view.reorganize());
        this.view.linkButton.on('click.link', () => this.onToggleLinking());
        // this.view.cropButton.on('click.crop', () => this.onToggleCrop());
        // this.view.focusButton.on('click.focus', () => this.onToggleFocus());
        this.view.interpolateButton.on('click.interp', () => this.onInterpolate());
        this.view.deleteButton.on('click.delete', () => this.onToggleDeleting());
        this.view.saveButton.on('click.save', () => this.onClickSave());
        this.view.clearButton.on('click.clear', () => this.onClickClear());


        this.view.clearButton.on('mouseover', () => {this.showClearInstructionBox()});
        this.view.clearButton.on('mouseout', () => {this.hideClearInstructionBox()});
        this.view.linkButton.on('mouseover', () => {this.showLinkInstructionBox()});
        this.view.linkButton.on('mouseout', () => {this.hideLinkInstructionBox()});
        this.view.interpolateButton.on('mouseover', () => {this.showInterpolateInstructionBox()});
        this.view.interpolateButton.on('mouseout', () => {this.hideInterpolateInstructionBox()});
        this.view.addButton.on('mouseover', () => {this.showAddInstructionBox()});
        this.view.addButton.on('mouseout', () => {this.hideAddInstructionBox()});
        this.view.filterButton.on('mouseover', () => {this.showFilterInstructionBox()});
        this.view.filterButton.on('mouseout', () => {this.hideFilterInstructionBox()});
        this.view.launchButton.on('mouseover', () => {this.showLaunchInstructionBox()});
        this.view.launchButton.on('mouseout', () => {this.hideLaunchInstructionBox()});
        this.view.saveButton.on('mouseover', () => {this.showSaveInstructionBox()});
        this.view.saveButton.on('mouseout', () => {this.hideSaveInstructionBox()});
        this.view.deleteButton.on('mouseover', () => {this.showDeleteInstructionBox()});
        this.view.deleteButton.on('mouseout', () => {this.hideDeleteInstructionBox()});

        // let launchViewerButton = document.getElementsByClassName('launch-button')[0];
        // // launchViewerButton.on('mouseover', () => {this.showQrCode()});
        // // launchViewerButton.on('onmouseout', () => {this.hideQrCode()});
        // launchViewerButton.onmouseover = (() => {this.showQrCode()});
        // launchViewerButton.onmouseout = (() => {this.hideQrCode()});

    }

    /**
     * initializes the handler for clicking on the lightbox
     * when clicked, the lightbox disappears
     */
    initLightboxHandler() {
        this.view.lightbox.on('click', () => {
            this.view.lightbox.classed('on', false);
        });
    }

    onClickClear() {
        let clearContainer = document.getElementById("clear-popup");
        // clearContainer.innerHTML = ("Click to confirm clear all.");
        clearContainer.innerHTML = ("Are you sure you would like to delete everything permanently?<br><br>Click to confirm.");
        clearContainer.style.fontSize = "14px";
        clearContainer.style.display = "block";
        clearContainer.style.paddingTop = "32px";
        clearContainer.style.left = "550px";
        clearContainer.style.textAlign = "center";
        clearContainer.style.height = "100px";
        clearContainer.style.width = "300px";
        clearContainer.style.borderRadius = "3px";
        clearContainer.style.background = "white";
        clearContainer.style.opacity = "0.8";
        clearContainer.style.color = "black";
        clearContainer.addEventListener('click',() => this.clearAllNodes());

        let exitClear = document.getElementById("exit-clear");
        exitClear.style.display = "block";
        exitClear.innerHTML = ("x");
        exitClear.style.color = "black";
        exitClear.style.left = "895px";
        exitClear.style.top = "253px";
        exitClear.style.cursor = "pointer";
        exitClear.style.textAlign = "center";
        exitClear.style.background = "white";
        exitClear.style.opacity = "0.5";
        exitClear.style.borderRadius = "2px";
        exitClear.style.height = "20px";
        exitClear.style.width = "20px";
        exitClear.style.padding = "2px";
        exitClear.addEventListener('click',() => this.doNotClear());
    }

    clearAllNodes() {
      let clearContainer = document.getElementById("clear-popup");
      clearContainer.style.display = "none";
      let exitClear = document.getElementById("exit-clear");
      exitClear.style.display = "none";
      this.graphController.clearGraph();

    }
    doNotClear() {
      let exitClear = document.getElementById("exit-clear");
      exitClear.style.display = "none";
      let clearContainer = document.getElementById("clear-popup");
      clearContainer.style.display = "none";

    }


    showDeleteInstructionBox() {
      let deleteButton = document.getElementsByClassName("delete-button")[0];
      // deleteButton.style.transform = "skewY(-10deg)";
      let deleteButtonDiv = document.getElementsByClassName("delete-instructionbox")[0];
      // console.log('show indstruction box was created');
      deleteButtonDiv.innerHTML = ("Click on nodes to delete them");
      deleteButtonDiv.style.display = "block";
      deleteButtonDiv.style.width = "200px";
      deleteButtonDiv.style.borderRadius = "1.7px";
      deleteButtonDiv.style.background = "white";
      deleteButtonDiv.style.opacity = ".85";
      deleteButtonDiv.style.color = "black";
      deleteButtonDiv.style.padding = "5px";
      deleteButtonDiv.style.margin = "3px";
    }
    hideDeleteInstructionBox() {
      let deleteButton = document.getElementsByClassName("delete-button")[0];
      // deleteButton.style.transform = "skewY(0deg)";
      let deleteButtonDiv = document.getElementsByClassName("delete-instructionbox")[0];
      deleteButtonDiv.style.display = "none";
      // deleteButtonDiv.innerHTML = ("");
    }

    showSaveInstructionBox() {
      let saveButton = document.getElementsByClassName("save-button")[0];
      // saveButton.style.transform = "skewY(-20deg)";
      let saveButtonDiv = document.getElementsByClassName("save-instructionbox")[0];
      // console.log('show indstruction box was created');
      saveButtonDiv.innerHTML = ("Saves all nodes");
      saveButtonDiv.style.display = "block";
      saveButtonDiv.style.borderRadius = "1.7px";
      saveButtonDiv.style.width = "150px";
      saveButtonDiv.style.background = "white";
      saveButtonDiv.style.opacity = ".85";
      saveButtonDiv.style.color = "black";
      saveButtonDiv.style.padding = "5px";
      saveButtonDiv.style.margin = "3px";
    }
    hideSaveInstructionBox() {
      let saveButton = document.getElementsByClassName("save-button")[0];
      // saveButton.style.transform = "skewY(0deg)";
      let saveButtonDiv = document.getElementsByClassName("save-instructionbox")[0];
      //let instbox = document.createElement('div');
      console.log('hide indstruction box was created');
      //clearButtonArea.append(instbox);
      saveButtonDiv.style.display = "none";
    }

    showAddInstructionBox() {
      let addButton = document.getElementsByClassName("add-button")[0];
      // addButton.style.transform = "skewY(-15deg)";
      let addButtonDiv = document.getElementsByClassName("add-instructionbox")[0];
      console.log('show indstruction box was created');
      addButtonDiv.innerHTML = ("Add a random new node");
      addButtonDiv.style.display = "block";
      addButtonDiv.style.width = "200px";
      addButtonDiv.style.borderRadius = "1.7px";
      addButtonDiv.style.background = "white";
      addButtonDiv.style.opacity = ".85";
      addButtonDiv.style.color = "black";
      addButtonDiv.style.padding = "5px";
      addButtonDiv.style.margin = "3px";
    }
    hideAddInstructionBox() {
      let addButton = document.getElementsByClassName("add-button")[0];
      // addButton.style.transform = "skewY(0deg)";
      let addButtonDiv = document.getElementsByClassName("add-instructionbox")[0];
      addButtonDiv.style.display = "none";
    }

    showFilterInstructionBox() {
      let filterButton = document.getElementsByClassName("filter-button")[0];
      // filterButton.style.transform = "skewY(-15deg)";
      let filterButtonDiv = document.getElementsByClassName("filter-instructionbox")[0];
      console.log('show indstruction box was created');
      filterButtonDiv.innerHTML = ("Select the range of content sources that you can explore");
      filterButtonDiv.style.display = "block";
      filterButtonDiv.style.borderRadius = "1.7px";
      filterButtonDiv.style.width = "270px";
      filterButtonDiv.style.background = "white";
      filterButtonDiv.style.opacity = ".85";
      filterButtonDiv.style.color = "black";
      filterButtonDiv.style.padding = "5px";
      filterButtonDiv.style.margin = "3px";
    }
    hideFilterInstructionBox() {
      let filterButton = document.getElementsByClassName("filter-button")[0];
      // filterButton.style.transform = "skewY(0deg)";
      let filterButtonDiv = document.getElementsByClassName("filter-instructionbox")[0];
      filterButtonDiv.style.display = "none";
    }

    showInterpolateInstructionBox() {
      let interpolateButton = document.getElementsByClassName("interpolate-button")[0];
      // interpolateButton.style.transform = "skewY(-20deg)";
      let interpolateButtonDiv = document.getElementsByClassName("interpolate-instructionbox")[0];
      // console.log('show indstruction box was created');
      interpolateButtonDiv.innerHTML = ("Click on two nodes to find the concepts that connect them");
      interpolateButtonDiv.style.display = "block";
      interpolateButtonDiv.style.borderRadius = "1.7px";
      interpolateButtonDiv.style.width = "240px";
      interpolateButtonDiv.style.background = "white";
      interpolateButtonDiv.style.opacity = ".85";
      interpolateButtonDiv.style.color = "black";
      interpolateButtonDiv.style.padding = "5px";
      interpolateButtonDiv.style.margin = "3px";
    }
    hideInterpolateInstructionBox() {
      let interpolateButton = document.getElementsByClassName("interpolate-button")[0];
      // interpolateButton.style.transform = "skewY(0deg)";
      let interpolateButtonDiv = document.getElementsByClassName("interpolate-instructionbox")[0];
      //let instbox = document.createElement('div');
      console.log('hide indstruction box was created');
      //clearButtonArea.append(instbox);
      interpolateButtonDiv.style.display = "none";
    }

    showLaunchInstructionBox() {
      let launchButton = document.getElementsByClassName("launch-button")[0];
      // launchButton.style.transform = "skewY(-15deg)";
      let launchButtonDiv = document.getElementsByClassName("launch-instructionbox")[0];
      console.log('show indstruction box was created');
      launchButtonDiv.innerHTML = ("Launch Design Daydreams: <br><b><em>sideways.media.mit.edu/daydreamsviewer</em></b>");
      // launchButtonDiv.innerHTML += ("<img src=\"../../heroku.png\" width=\"70px\" height=\"70px\">");
      launchButtonDiv.style.display = "block";
      launchButtonDiv.style.borderRadius = "1.7px";
      launchButtonDiv.style.width = "320px";
      launchButtonDiv.style.height = "42px";
      launchButtonDiv.style.background = "white";
      launchButtonDiv.style.opacity = ".85";
      launchButtonDiv.style.color = "black";
      launchButtonDiv.style.padding = "5px";
      launchButtonDiv.style.margin = "3px";

      let castContainer = document.getElementById("cast-popup");
      castContainer.innerHTML = ("<img src=\"../../heroku.png\" width=\"150px\" height=\"150px\">");
      castContainer.style.display = "block";
      // castContainer.style.left = "200px";

    }
    hideLaunchInstructionBox() {
      let launchButton = document.getElementsByClassName("launch-button")[0];
      // launchButton.style.transform = "skewY(0deg)";
      let launchButtonDiv = document.getElementsByClassName("launch-instructionbox")[0];
          let castContainer = document.getElementById("cast-popup");
      //let instbox = document.createElement('div');
      console.log('hide indstruction box was created');
      //clearButtonArea.append(instbox);
      launchButtonDiv.style.display = "none";
      castContainer.style.display = "none";
    }

    showLinkInstructionBox() {
      let linkButton = document.getElementsByClassName("link-button")[0];
      // linkButton.style.transform = "skewY(-20deg)";

      let linkButtonDiv = document.getElementsByClassName("link-instructionbox")[0];
      console.log('show indstruction box was created');
      linkButtonDiv.innerHTML = ("Link two nodes and add your own notes");
      linkButtonDiv.style.display = "block";
      linkButtonDiv.style.borderRadius = "1.7px";
      linkButtonDiv.style.width = "200px";
      linkButtonDiv.style.background = "white";
      linkButtonDiv.style.opacity = ".85";
      linkButtonDiv.style.color = "black";
      linkButtonDiv.style.padding = "5px";
      linkButtonDiv.style.margin = "3px";
    }
    hideLinkInstructionBox() {
      let linkButton = document.getElementsByClassName("link-button")[0];
      // linkButton.style.transform = "skewY(0deg)";
      let linkButtonDiv = document.getElementsByClassName("link-instructionbox")[0];
      //let instbox = document.createElement('div');
      console.log('hide indstruction box was created');
      //clearButtonArea.append(instbox);
      linkButtonDiv.style.display = "none";
    }

    showClearInstructionBox() {
      let clearButton = document.getElementsByClassName("clear-button")[0];
      // clearButton.style.transform = "skewY(-20deg)";

      let clearButtonDiv = document.getElementsByClassName("clear-instructionbox")[0];
      console.log('show indstruction box was created');
      clearButtonDiv.innerHTML = ("Clears all nodes");
      clearButtonDiv.style.display = "block";
      clearButtonDiv.style.borderRadius = "1.7px";
      clearButtonDiv.style.width = "150px";
      clearButtonDiv.style.background = "white";
      clearButtonDiv.style.opacity = ".85";
      clearButtonDiv.style.color = "black";
      clearButtonDiv.style.padding = "5px";
      clearButtonDiv.style.margin = "3px";
    }
    hideClearInstructionBox() {
      let clearButton = document.getElementsByClassName("clear-button")[0];
      // clearButton.style.transform = "skewY(0deg)";
      let clearButtonDiv = document.getElementsByClassName("clear-instructionbox")[0];
      //let instbox = document.createElement('div');
      console.log('hide indstruction box was created');
      //clearButtonArea.append(instbox);

      clearButtonDiv.style.display = "none";
    }

    /**
     * save on click
     */
    onClickSave() {
        this.graphController.save();
        console.log("save was successfully called");
    }

    /**
     * toggles the interpolate state on or off.
     * when on, clicking two nodes gets
     * the shortest path between their titles in concept net
     * and makes new intermediary nodes corresponding to this path
     */
    onInterpolate() {
        this.graphController.state.toggle('interpolating');
    }

    /**
     * toggles the physics on or off.
     */
    onTogglePhysics() {
        this.view.togglePhysics();
        this.view.physicsButton.classed('off', !this.view.physicsButton.classed('off'));
    }

    /**
     * toggles the editing state.
     * when on, typing in a tooltip edits it
     * [not working]
     */
    onToggleEditing() {
        this.graphController.state.toggle('EDITING');
    }

    /**
     * toggles the deleting state
     * when on, clicking on a node or link deletes it
     */
    onToggleDeleting() {
        this.graphController.state.toggle('DELETING');
    }

    /**
     * turns the highlighting state on or off.
     * when on, dragging on a text node highlights the text.
     * [not working currently]
     */
    onToggleHighlighting() {
        this.graphController.state.toggle('HIGHLIGHTING');
    }

    /**
     * turns the linking state on or off.
     * when on, clicking on any two nodes links them
     */
    onToggleLinking() {
        this.graphController.state.toggle('LINKING');
    }

    /**
     * turns the cropping state on or off.
     * when on, dragging on any node crops it
     */
    onToggleCrop() {
        this.graphController.state.toggle('CROPPING');
    }

    /**
     * turns the focusing state on or off.
     * when on, clicking on any node zooms it in
     */
    onToggleFocus() {
        this.graphController.state.toggle('FOCUSING');
    }


    /**
     * binds the handlers for clicking on the add-node buttons
     */
    initAddNodeHandler() {
        this.view.nodeAdder.on('click', (apiName) => this.onNodeAdd(apiName));
        this.view.addButton.on('click', () => this.onNodeAddToggle());
    }

    /**
     * binds the handlers for clicking on the filter-node buttons
     */
    initFiltersHandler() {
        this.view.nodeFilters.on('click', (apiName) => this.onNodeFilter(apiName));
        this.view.filterButton.on('click', () => this.onNodeFilterToggle());
        this.view.randomizeFilter.on('click', () => this.onNodeRandomizeSources());
    }

    /**
     * binds the handlers for clicking on the cast
     */
    initCastHandler() {
        this.view.launchMenuItems.on('click', (something) => this.onCastClick(something));
        //somethng should be the menu item object
        this.view.launchButton.on('click', () => this.onCastToggle());
    }


    /**
     * Displays qr code & instructions for casting to device
     *
     * TODO: curently called at initFunctionButtonHandlers() -> only gets called once, despite mouseover/mouseout detected
     */
    showQrCode() {
      //this.graphController.showPopupOnHover(); //keep this or the other
      //this.state.set('launchhovering'); //remember to delete these

      console.log("showQrCode was called;");

      //let launchViewerButton = document.getElementsByClassName('launch-button')[0];
      let castContainer = document.getElementById("cast-popup");

      castContainer.innerHTML = ("Design Daydreams<br><br>" +
        "Scan QR code and go to website to activate new Design Daydreams viewer.<br><br>");
      castContainer.innerHTML += ("<img src=\"../../heroku.png\" width=\"150px\" height=\"150px\"><br><br>");
      castContainer.innerHTML += ("<button id='cast-popup-button' type='button'>done</button><br><br>");
      castContainer.style.position = "absolute";
      castContainer.style.zIndex = "5";
      castContainer.style.top = "20%";
      castContainer.style.left = "30%";
      castContainer.style.width = "50%";
      castContainer.style.height = "40%";
      castContainer.style.fontSize = "18px";
      castContainer.style.color = "black";
      castContainer.style.backgroundColor = "rgba(242, 242, 242, 0.9)";
      castContainer.style.padding = "50px";
      castContainer.style.borderRadius = "8px";
    }

    /**
     * Hides the qr code used for casting
     */
    hideQrCode() {
      console.log("hideQrCode was called;");
      let castContainer = document.getElementById("cast-popup");
      castContainer.style.display = "none";
    }

    /**
     * 1. click show add
     */
    onNodeAddToggle() {
      let addMenuButton = document.getElementsByClassName("add-button")[0];
      //already open
      if (this.view.adders.classed('on')) {
        this.view.adders.classed('on', false);
        // addMenuButton.style.backgroundColor="black";
        addMenuButton.style.transform="skewY(0deg)";
        addMenuButton.style.opacity=".6";
        // this.view.filters.classed('on', false);

      } else {
        this.view.adders.classed('on', true);

        // addMenuButton.style.backgroundColor="red";
        addMenuButton.style.transform="skewY(-10deg)";
        addMenuButton.style.opacity="1";
        this.view.filters.classed('on', false);
      }
    }

    /**
     * on click show filters
     */
    onNodeFilterToggle() {
      // let open = !this.view.filters.classed('on');
      // this.closeMenus();
      // this.view.filters.classed('on', open);
      let filterMenuButton = document.getElementsByClassName("filter-button")[0];
      //already open
      if (this.view.filters.classed('on')) {
        this.view.filters.classed('on', false);
        // addMenuButton.style.backgroundColor="black";
        filterMenuButton.style.transform="skewY(0deg)";
        filterMenuButton.style.opacity=".6";
        this.closeMenus();

      } else {
        this.view.filters.classed('on', true);
        this.view.adders.classed('on', false);
        // addMenuButton.style.backgroundColor="red";
        filterMenuButton.style.transform="skewY(-10deg)";
        filterMenuButton.style.opacity="1";
      }
    }

    /**
     * on click show devices for casting
     */
    onCastToggle() {
      // let launchMenuButton = document.getElementsByClassName("launch-button")[0];
      // if (this.view.launchMenuContainer.classed('on')) {
      //   this.view.launchMenuContainer.classed('on', false);
      //   // addMenuButton.style.backgroundColor="black";
      //   launchMenuButton.style.transform="skewY(0deg)";
      //   launchMenuButton.style.opacity=".6";
      //   this.closeMenus();
      // } else {
      //   this.view.launchMenuContainer.classed('on', true);
      //   this.graphController.daydreams.flashDeviceSymbols();
      //   // addMenuButton.style.backgroundColor="red";
      //   launchMenuButton.style.transform="skewY(-10deg)";
      //   launchMenuButton.style.opacity="1";
      // }

      let open = !this.view.launchMenuContainer.classed('on');
      this.closeMenus();
      this.view.launchMenuContainer.classed('on', open);
      if (open) {
        this.graphController.daydreams.flashDeviceSymbols();
      }

    }

    closeMenus() {
      this.view.adders.classed('on', false);
      this.view.filters.classed('on', false);
      this.view.launchMenuContainer.classed('on', false);
    }

    /**
     * randomizes the sources in view and model
     */
    onNodeRandomizeSources() {
        this.graphController.availableAPI = [];
        this.view.filters.selectAll('.filter-toggle').classed('on', false);
        let random = randomizeSources(apis.available);
        for (let i = 0; i < random.length; i++) {
            let filtButton = this.view.filters.select(`.filter-button--${random[i]}`);
            filtButton.classed('on', true);
            this.addAPI(random[i]);
        }
    }

    /**
     * click on api name to toggle through the selection of filters
     * toggle node to the current array of sources if not already present
     * @param {String} apiName
     */
    onNodeFilter(apiName) {
        let filtButton = this.view.filters.select(`.filter-button--${apiName}`);
        filtButton.classed('on', !filtButton.classed('on'));

        let apis = this.graphController.availableAPI;
        if (apis.includes(apiName)) {
            const index = apis.indexOf(apiName);
            apis.splice(index, 1);
        } else {
            this.addAPI(apiName);
        }
    }

    onCastClick(menuItem){
      console.log('cast click!', menuItem);

      if (menuItem.key == 'adddevice') {
        console.log("detected that menuItem.key is adddevice!");
        this.graphController.showCastPopup();
      } else {
        this.graphController.castToDevice(menuItem.key);
        this.closeMenus();

      }
    }

    /**
     * helper function to confine the number of apis selected to 5
     * @param {String} apiName
     */
    addAPI(apiName) {
        let apis = this.graphController.availableAPI;
        if (apis.length > 4) {
            let removed = apis.shift();
            this.view.filters.select(`.filter-button--${removed}`)
                             .classed('on', false);
        }
        apis.push(apiName);
    }

    /**
     * 2. click api name to add that type of node
     * @param {*} apiName
     */
    onNodeAdd(apiName) {
        this.graphController.state.set('adding');
        this.view.svg.on('click.add', this.onNodeAddClick(apiName));
    }


    /**
     * 3. click svg location
     * @param {string} apiName
     * @return {Function}
     */
    onNodeAddClick(apiName) {
        return () => {
            if (apiName === 'connector') {
                this.graphController.inputController.showInputBoxAtLocation(d3.event.x, d3.event.y);
            } else {
                let apiSource = apis[apiName] ? apis[apiName].random() : {};
                let type = apiSource.type ? apiSource.type : apiName;
                this.graphController.addNode(type, apiSource, {}, d3.event.x, d3.event.y);
                this.onNodeAddToggle();
            }
            this.view.svg.on('click.add', null);
            this.graphController.state.set('none');
        };
    }

}
